import React from 'react'
import './Keydates.css'
const Keydates = () => {
    return (
        <div className='Keydates'>
            <span className="heading">Key <span>dates</span></span>
            <table border="4">
                <tbody>
                    <tr>
                        <td>Submission Deadline:</td>
                        <td>
                            31 October 2025 <b>(Submission Closed)</b>
                            {/* &nbsp;&nbsp; 5 November 2024 */}
                        </td>

                    </tr>

                    <tr>
                        <td>Acceptance Notification:</td>
                        <td>Before 30th November 2025</td>
                    </tr>

                    <tr>
                        <td>Final Paper & Author Registration Closes:</td>
                        <td> 24th November 2025</td>
                    </tr>

                    <tr>
                        <td>Conference:</td>
                        <td>22-23 January 2026</td>
                    </tr>

                </tbody>
            </table>
        </div>
    )
}

export default Keydates
